import http from '@/services/rest/rest.service';

export default {
    login(body: {
        username: string;
        password: string;
        captchaString: string;
        captchaCheck: string;
    }): Promise<{ token: string }> {
        return http.post(`auth/login`, body);
    },
    loginRemote(body: { token: string }): Promise<{ token: string }> {
        return http.post(`auth/login-remote`, body);
    },
    logout(): Promise<void> {
        return http.post(`auth/logout`);
    }
};
